import Promotions from './Promotions.container';

export default Promotions;
